<template>
    <div class="right-block">
        <div class="float-container">
            <el-popover 
                placement="left" 
                width="220px" 
                trigger="click"
                popper-class="service-popover"
            >
                <div class="popover-content">
                    <div class="popover-header">
                        <i class="el-icon-service"></i>
                        <span>咨询客服QQ</span>
                    </div>
                    <div class="popover-body">
                        <div class="qr-wrapper">
                            <img src="@/assets/qq.png" class="qr-code" alt="客服QQ">
                        </div>
                        <div class="service-info">
                            <div class="info-item">
                                <span class="label">工作日：</span>
                                <span class="time">10:00 ~ 17:00</span>
                            </div>
                            <div class="info-item">
                                <span class="label">休息日：</span>
                                <span class="time">11:30 ~ 16:00</span>
                            </div>
                        </div>
                        <div class="service-tips">
                            <p>非工作时间欢迎在线留言</p>
                            <p>客服上线将第一时间处理</p>
                        </div>
                    </div>
                </div>
                <div slot="reference" class="service-btn">
                    <i class="el-icon-headset"></i>
                    <span class="btn-text">客服</span>
                </div>
            </el-popover>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RightBlock',
    data() {
        return {
            dialogVisible: false
        }
    }
}
</script>

<style lang="scss" scoped>
.right-block {
    .float-container {
        position: fixed;
        right: 24px;
        bottom: 120px;
        z-index: 999;
    }

    .service-btn {
        width: 56px;
        height: 56px;
        background: linear-gradient(135deg, #409EFF 0%, #2b7de9 100%);
        border-radius: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
        transition: all 0.3s ease;

        &:hover {
            transform: scale(1.08);
            box-shadow: 0 6px 20px rgba(64, 158, 255, 0.5);
        }

        &:active {
            transform: scale(1.02);
        }

        i {
            font-size: 22px;
            color: #fff;
        }

        .btn-text {
            font-size: 12px;
            color: #fff;
            margin-top: 2px;
            font-weight: 500;
        }
    }

    .popover-content {
        .popover-header {
            display: flex;
            align-items: center;
            justify-content: center;
            padding-bottom: 12px;
            border-bottom: 1px solid #ebeef5;
            margin-bottom: 16px;

            i {
                font-size: 20px;
                color: #409EFF;
                margin-right: 8px;
            }

            span {
                font-size: 16px;
                font-weight: 600;
                color: #303133;
            }
        }

        .popover-body {
            .qr-wrapper {
                text-align: center;
                margin-bottom: 16px;

                .qr-code {
                    width: 50px ;
                    height: 50px;
                    border-radius: 8px;
                    border: 1px solid #ebeef5;
                    padding: 4px;
                    background: #fff;
                }
            }

            .service-info {
                background: #f8fafc;
                border-radius: 8px;
                padding: 12px;
                margin-bottom: 12px;

                .info-item {
                    display: flex;
                    align-items: center;
                    line-height: 28px;

                    .label {
                        font-size: 14px;
                        color: #303133;
                        font-weight: 500;
                    }

                    .time {
                        font-size: 14px;
                        color: #909399;
                    }
                }
            }

            .service-tips {
                text-align: center;

                p {
                    font-size: 12px;
                    color: #909399;
                    line-height: 22px;
                    margin: 0;
                }
            }
        }
    }
}

</style>

<style lang="scss">
/* 全局样式 - 弹出层自定义 */
.service-popover {
    border-radius: 12px !important;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
    border: none !important;

    .popover-content {
        .popover-header {
            display: flex;
            align-items: center;
            justify-content: center;
            padding-bottom: 12px;
            border-bottom: 1px solid #ebeef5;
            margin-bottom: 12px;

            i {
                font-size: 18px;
                color: #409EFF;
                margin-right: 6px;
            }

            span {
                font-size: 15px;
                font-weight: 600;
                color: #303133;
            }
        }

        .popover-body {
            .qr-wrapper {
                text-align: center;
                margin-bottom: 12px;

                .qr-code {
                    width: 120px !important;
                    height: 120px !important;
                    max-width: 120px !important;
                    max-height: 120px !important;
                    border-radius: 6px;
                    border: 1px solid #ebeef5;
                    padding: 4px;
                    background: #fff;
                }
            }

            .service-info {
                background: #f8fafc;
                border-radius: 6px;
                padding: 10px;
                margin-bottom: 10px;

                .info-item {
                    display: flex;
                    align-items: center;
                    line-height: 24px;

                    .label {
                        font-size: 13px;
                        color: #303133;
                        font-weight: 500;
                    }

                    .time {
                        font-size: 13px;
                        color: #909399;
                    }
                }
            }

            .service-tips {
                text-align: center;

                p {
                    font-size: 12px;
                    color: #909399;
                    line-height: 20px;
                    margin: 0;
                }
            }
        }
    }
}
</style>
